import { render } from "./index.vue?vue&type=template&id=276800be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=276800be&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276800be"],['__file',"src/views/layout/components/Sidebar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "276800be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('276800be', __exports__)) {
    console.log('reload')
    api.reload('276800be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=276800be&scoped=true", () => {
    console.log('re-render')
    api.rerender('276800be', render)
  })

}


export default __exports__